import React, { useState } from 'react';
import { formatCurrency, formatCurrencyShort } from '../utils/currency';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Preloader from '../components/Preloader';
import ScrollToTop from '../components/ScrollToTop';
import PageTitle from '../components/PageTitle';

const faqs = [
  {
    q: 'What are your room rates?',
    a: 'Greatwood Standard ₦40,000/night · Executive ₦50,000/night · Special ₦80,000/night · Presidential Suite ₦150,000/night. All rates include free WiFi, 24h power and AC.',
  },
  {
    q: 'What are check-in and check-out times?',
    a: 'Check-in is from 12:00 PM. Check-out is by 11:00 AM. Early check-in and late check-out can be arranged subject to availability — please call ahead.',
  },
  {
    q: 'Is parking free for guests?',
    a: 'Yes. We have a spacious, secure, CCTV-monitored parking compound that is completely free for all guests throughout their stay.',
  },
  {
    q: 'Does the hotel have a swimming pool?',
    a: 'Yes — our outdoor pool with dual fountain jets and comfortable poolside seating is available to all guests, maintained to international standards.',
  },
  {
    q: 'Is there 24-hour power and security?',
    a: 'Yes. Industrial backup generators ensure uninterrupted power 24 hours a day. We also have round-the-clock CCTV and on-site security personnel.',
  },
  {
    q: 'Can you host events and conferences?',
    a: 'Absolutely. Our event hall seats up to 500 guests with a gold-mirror ceiling and hardwood floors — perfect for weddings, conferences and corporate dinners. We also have a 20-seat boardroom.',
  },
  {
    q: 'How do I make a reservation?',
    a: 'Call us on 0807 698 8183 or 0817 629 1933, WhatsApp the same numbers, email , or use the contact form on our website.',
  },
];

export default function Faq() {
  const [active, setActive] = useState(null);
  return (
    <div className="page-wrapper">
      <Preloader />
      <Header />
      <PageTitle
        title="Frequently Asked Questions"
        breadcrumbs={[{ label: 'FAQ' }]}
      />

      <section style={{ padding: '64px 0' }}>
        <div className="auto-container">
          <div className="row g-5">
            <div className="col-lg-4">
              <span className="h2-label">FAQ</span>
              <h2
                style={{
                  fontFamily: 'var(--gw-font-h,serif)',
                  fontSize: 'clamp(26px,3vw,42px)',
                  color: '#111',
                  lineHeight: 1.15,
                  margin: '10px 0 16px',
                }}
              >
                Got Questions?
              </h2>
              <p
                style={{
                  color: '#666',
                  fontSize: 14,
                  lineHeight: 1.8,
                  marginBottom: 24,
                }}
              >
                Find answers to the most common questions about Greatwood Hotel.
                Still need help? Call us directly.
              </p>
              <div
                style={{
                  background: '#f9f8f6',
                  border: '1px solid #e8e3dc',
                  borderRadius: 6,
                  padding: '22px 20px',
                  marginBottom: 16,
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    color: '#999',
                    marginBottom: 6,
                    textTransform: 'uppercase',
                    letterSpacing: 1,
                  }}
                >
                  Call Us
                </div>
                <a
                  href="tel:+2348076988183"
                  style={{
                    display: 'block',
                    fontSize: 16,
                    fontWeight: 700,
                    color: '#111',
                    textDecoration: 'none',
                    marginBottom: 4,
                  }}
                >
                  0807 698 8183
                </a>
                <a
                  href="tel:+2348176291933"
                  style={{
                    display: 'block',
                    fontSize: 14,
                    color: '#777',
                    textDecoration: 'none',
                  }}
                >
                  0817 629 1933
                </a>
              </div>
              <a
                href="https://wa.me/2348076988183"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  padding: '11px 18px',
                  background: '#25d366',
                  color: '#fff',
                  borderRadius: 3,
                  textDecoration: 'none',
                  fontSize: 13,
                  fontWeight: 700,
                  marginBottom: 12,
                }}
              >
                <i className="fab fa-whatsapp"></i>WhatsApp: 0807 698 8183
              </a>
              <Link
                to="/contact"
                className="h2-btn-ghost"
                style={{ display: 'block', textAlign: 'center' }}
              >
                Full Contact Page
              </Link>
            </div>
            <div className="col-lg-8">
              {faqs.map((faq, i) => (
                <div key={i} style={{ borderBottom: '1px solid #e8e3dc' }}>
                  <button
                    style={{
                      width: '100%',
                      textAlign: 'left',
                      padding: '18px 40px 18px 0',
                      background: 'none',
                      border: 'none',
                      fontSize: 16,
                      fontWeight: 600,
                      color: active === i ? '#b08d57' : '#111',
                      cursor: 'pointer',
                      position: 'relative',
                      fontFamily: 'var(--gw-font-h,serif)',
                      transition: 'color 0.2s',
                    }}
                    onClick={() => setActive(active === i ? null : i)}
                  >
                    {faq.q}
                    <span
                      style={{
                        position: 'absolute',
                        right: 0,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        width: 28,
                        height: 28,
                        background: active === i ? '#b08d57' : '#f9f8f6',
                        border: '1px solid #e8e3dc',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 14,
                        color: active === i ? '#fff' : '#b08d57',
                        transition: 'all 0.2s',
                        flexShrink: 0,
                      }}
                    >
                      {active === i ? '−' : '+'}
                    </span>
                  </button>
                  {active === i && (
                    <div
                      style={{
                        padding: '0 40px 18px 0',
                        fontSize: 14,
                        color: '#555',
                        lineHeight: 1.8,
                      }}
                    >
                      {faq.a}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <ScrollToTop />
    </div>
  );
}
